import { IFilter, IPaging, IPagingFromTo } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchReportData = async (
  filter: IDataProviderFilter,
  paging: IPaging | IPagingFromTo
) => {
  const url = proxy(`/webservice/197/sp/v3/spJBPComposedReport/call`)
  const filters = filter.filters as IFilter[]
  const dataForFilter = filters.find((el) => el.field === 'dataForFilter')
  const uniqueId = filters.find((el) => el.field === 'uniqueId')

  if (uniqueId && dataForFilter) {
    const pageSize = (paging as IPaging).pageSize
    const page = (paging as IPaging).page
    const payload = {
      'p.filters': dataForFilter.value,
      'p.uniqueId': uniqueId.value,
      'p.take': pageSize,
      'p.skip': pageSize * page,
    }
    const [accessToken] = getTokens()
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    const response = await Rest.post({ url, payload, headers })
    const rows = (response && response['Rows']) || []

    return { Data: rows }
  }

  return { Data: [] }
}
